<template>
    <tr>
        <td valign="middle" class="mx-auto text-center fw-bold">
            <router-link :to="{name:'Product', params:{id:product.id}}" class="nav-link px-0 active my-auto">
                {{product.name}}
            </router-link>
        </td>
        <td valign="middle" class="mx-auto text-center">
            <table class="table m-0">
                <tbody>
                    <tr v-for="(price, index) of product.prices" :key="index">
                        <td valign="middle" :class="{'border-0': index == product.prices.length-1}">
                            {{price.quantity}} por ${{price.price}}
                        </td>
                    </tr>
                </tbody>
            </table>
        </td>
        <td valign="middle" class="mx-auto text-center my-auto">
            <button class="btn btn-outline-success" @click="edit">
                <i class="fas fa-pen"></i>
            </button>
        </td>
        <td valign="middle" class="mx-auto text-center">
            <button class="btn btn-outline-danger" @click="del">
                <i class="fas fa-trash"></i>
            </button>
        </td>
    </tr>
</template>

<script>
import { fb } from '../firebase';

export default {
    name: 'TableProduct',
    props: ['product'],
    methods:{
        del(){
            if(confirm("Esta seguro de que desea eliminar el producto?")){
                fb.deleteDocById('catalog', this.product.id).then(() => {
                    this.$emit('del', this.product.id);
                })
            }
        },
        edit(){
            this.$emit('edit', this.product)
        }
    },
}
</script>

<style lang="scss" scoped>
</style>